import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_EQUIPOS_JUEGOS = 'ALL_EQUIPOS_JUEGOS';
export const ACTIVO_EQUIPOS_JUEGOS = 'ACTIVO_EQUIPOS_JUEGOS';
export const LOADING_ALL_EQUIPOS_JUEGOS = 'LOADING_ALL_EQUIPOS_JUEGOS';
export const PARAMS_EQUIPOS_JUEGOS = 'PARAMS_EQUIPOS_JUEGOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const equiposJuegosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_EQUIPOS_JUEGOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_EQUIPOS_JUEGOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_EQUIPOS_JUEGOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_EQUIPOS_JUEGOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
